import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import apiService from '../../services/api';
import AchievementImage from '../Achievements/AchievementImage';

const AchievementItem = ({ achievement }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div 
      className="unlocked-achievements__item"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <div className="unlocked-achievements__image-container">
        <AchievementImage
          filename={achievement.image_filename}
          alt={achievement.name}
          className="unlocked-achievements__image"
        />
      </div>
      
      {showTooltip && (
        <div className="unlocked-achievements__tooltip">
          <div className="unlocked-achievements__tooltip-content">
            <h4 className="unlocked-achievements__tooltip-name">{achievement.name}</h4>
            <p className="unlocked-achievements__tooltip-description">{achievement.description}</p>
          </div>
        </div>
      )}
    </div>
  );
};

const UnlockedAchievements = ({ userId, achievements: achievementsProp, isPublicView = false, username = null }) => {
  const [achievements, setAchievements] = useState(achievementsProp || []);
  const [isLoading, setIsLoading] = useState(!achievementsProp);

  useEffect(() => {
    // If achievements are provided as props, use them directly
    if (achievementsProp) {
      setAchievements(achievementsProp);
      setIsLoading(false);
      return;
    }
    
    // Otherwise, fetch achievements if userId is provided
    if (userId) {
      fetchUnlockedAchievements();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, isPublicView, achievementsProp]);

  const fetchUnlockedAchievements = async () => {
    try {
      let response;
      
      if (isPublicView) {
        // Use public endpoint for public profiles (no auth required)
        response = await apiService.get(`/api/achievements/public/user/${userId}`);
      } else {
        // Use private endpoint for own profile (auth required)
        response = await apiService.get(`/api/achievements/user/${userId}`);
      }

      const data = await response.json();
      // Show all achievements in descending date order
      setAchievements(data);
    } catch (error) {
      console.error('Error fetching unlocked achievements:', error);
    } finally {
      setIsLoading(false);
    }
  };


  if (isLoading) {
    return (
      <div className="unlocked-achievements">
        <h3>Achievements</h3>
        <div className="unlocked-achievements__loading">Loading...</div>
      </div>
    );
  }

  if (achievements.length === 0) {
    return (
      <div className="unlocked-achievements">
        <h3>Achievements</h3>
        <div className="unlocked-achievements__empty">
          <p>No achievements unlocked yet!</p>
          <p>Start playing games to earn your first achievements.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="unlocked-achievements">
      <div className="unlocked-achievements__header">
        <h3>Achievements</h3>
        <Link 
          to={isPublicView && username ? `/profile/${username}/achievements` : '/achievements'} 
          className="unlocked-achievements__view-all"
        >
          View All
        </Link>
      </div>
      
      <div className="unlocked-achievements__grid">
        {achievements.map((achievement) => (
          <AchievementItem 
            key={achievement.id} 
            achievement={achievement} 
          />
        ))}
      </div>
      
    </div>
  );
};

export default UnlockedAchievements;